import { competitionService } from './competition';

const activityEvents = new Map();
let activeEventId;
export const teamsService = {
  register(masterEventId, activities) {
    activeEventId = masterEventId;
    activities.forEach(a => activityEvents.set(a.id, masterEventId));
  },
  getForActivity(activityId) {
    const masterEventId = activityEvents.get(activityId) || activeEventId;
    const teams = competitionService.peek(masterEventId).teams;
    const specific = teams.filter(t => t.activityId === activityId);
    return specific.length ? specific : teams.filter(t => !t.activityId);
  },
  getForMasterEvent(masterEventId) { return competitionService.peek(masterEventId).teams.filter(t => !t.activityId); },
  getAllForMasterEvent(masterEventId) { return competitionService.peek(masterEventId).teams; },
  async create({ masterEventId, activityId, name, members }) {
    await competitionService.command(masterEventId, null, 'teamCreate', { activityId, name, members });
  },
  async update(teamId, updates) {
    await competitionService.command(activeEventId, null, 'teamUpdate', { teamId, ...updates });
  },
  async delete(teamId) { await competitionService.command(activeEventId, null, 'teamDelete', { teamId }); },
  async addMember(teamId, userId) { await competitionService.command(activeEventId, null, 'teamAssign', { teamId, userId }); },
  async removeMember(teamId, userId) { await competitionService.command(activeEventId, null, 'teamAssign', { teamId, userId, remove: true }); },
  async generateRandomTeams(masterEventId, activityId, members, teamCount) {
    await competitionService.command(masterEventId, null, 'teamGenerate', { activityId, members, teamCount });
  },
  getRandomTeamNames(count) { return Array.from({ length: count }, (_, i) => `Team ${i + 1}`); },
  async inheritToActivity(masterEventId, activityId) {
    await competitionService.command(masterEventId, null, 'teamInherit', { activityId });
  },
};
